import React from "react";

const MovingCubes = ({
  primaryColor = "hsl(234 70% 70%)",
  numberOfCubes = 3,
  speed = 1, // in seconds
}) => {
  const containerStyle = {
    "--s": "25px",
    "--g": "5px",
    width: `calc(${numberOfCubes}*(1.353*var(--s) + var(--g)))`,
    display: "grid",
    justifyItems: "end",
    aspectRatio: `${numberOfCubes}`,
    overflow: "hidden",
    "--_m": "linear-gradient(90deg,#0000,#000 15px calc(100% - 15px),#0000)",
    WebkitMask: "var(--_m)",
    mask: "var(--_m)",
  };

  const animationStyle = {
    content: '""',
    width: "200%",
    background: `
      linear-gradient(90deg,${primaryColor} 50%,#0000 0),
      conic-gradient(from -90deg at var(--s) calc(0.353*var(--s)),
        #fff 135deg,#666 0 270deg,#aaa 0)
    `,
    backgroundBlendMode: "multiply",
    "--_m": `
      linear-gradient(to bottom right,
        #0000 calc(0.25*var(--s)),#000 0 calc(100% - calc(0.25*var(--s)) - 1.414*var(--g)),#0000 0),
      conic-gradient(from -90deg at right var(--g) bottom var(--g),#000 90deg,#0000 0)
    `,
    WebkitMask: "var(--_m)",
    mask: "var(--_m)",
    backgroundSize: `calc(100%/${numberOfCubes}) 100%, calc(100%/${numberOfCubes * 2}) 100%`,
    WebkitMaskSize: `calc(100%/${numberOfCubes * 2}) 100%`,
    maskSize: `calc(100%/${numberOfCubes * 2}) 100%`,
    WebkitMaskComposite: "source-in",
    maskComposite: "intersect",
    animation: `moveCubes ${speed}s infinite linear`,
  };

  return (
    <div className="relative">
      <style>
        {`
          @keyframes moveCubes {
            to {
              transform: translate(calc(100%/${numberOfCubes}))
            }
          }
        `}
      </style>
      <div style={containerStyle}>
        <div style={animationStyle} />
      </div>
    </div>
  );
};

export default MovingCubes;
